import { render, staticRenderFns } from "./AccettazioneSsnEditViewComponentOld.vue?vue&type=template&id=d85ae168&scoped=true"
import script from "./AccettazioneSsnEditViewComponentOld.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnEditViewComponentOld.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnEditViewComponentOld.vue?vue&type=style&index=0&id=d85ae168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85ae168",
  null
  
)

export default component.exports